export enum ModuleContext {
  SACHBEARBEITER = "SACHBEARBEITER",
  ANTRAGSTELLER = "ANTRAGSTELLER",
  GETEILT = "GETEILT"
}
